import React from 'react';

import {Button} from 'shells/button/button';
import {Checkbox} from 'shells/checkbox/checkbox';
import {CheckboxForGroup} from 'shells/checkbox/checkbox-for-group';
import {CheckboxGroup} from 'shells/checkbox/checkbox-group';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import type {Audience} from './types';

import styles from './preference-center.module.css';

type Props = {
    publicAudiences: Audience[];
    resubscribeUrl?: string;
    onSuccessfulResubscribe: () => void;
};

export function PreferenceCenterResubscribe(props: Props) {
    const [isGloballyResubscribed, setIsGloballyResubscribed] = React.useState(false);
    const [selectedAudiences, setSelectedAudiences] = React.useState<string[]>([]);

    return (
        <div className='mt-32'>
            <StackLegacy spacing={32}>
                <StackLegacy spacing={12}>
                    <Body color='light'>
                        You’re unsubscribed from all content and will not receive any additional
                        emails
                    </Body>
                    <Checkbox
                        // @ts-expect-error
                        id='resubscribe'
                        name='resubscribe'
                        checked={isGloballyResubscribed}
                        onChange={() => setIsGloballyResubscribed(!isGloballyResubscribed)}
                        label={
                            <div className='px-8'>
                                <Body color='dark' isBold={true}>
                                    Resubscribe me to email communication
                                </Body>
                            </div>
                        }
                    />
                </StackLegacy>
                <div className='pos-relative'>
                    {!isGloballyResubscribed && <div className={styles['disabled-overlay']} />}
                    <StackLegacy spacing={16}>
                        <CheckboxGroup
                            name='preference-group'
                            selectedValues={selectedAudiences}
                            onChange={setSelectedAudiences}
                        >
                            <div className={styles['preference-options-container']}>
                                {props.publicAudiences.map((audience) => (
                                    <CheckboxForGroup
                                        key={audience.id}
                                        value={audience.id}
                                        isLarge={false}
                                    >
                                        <div className={styles['preference-option']}>
                                            <Body color='dark' isBold={true}>
                                                {audience.name}
                                            </Body>
                                            <Body color='dark'>{audience.description}</Body>
                                        </div>
                                    </CheckboxForGroup>
                                ))}
                            </div>
                        </CheckboxGroup>
                        <Button
                            size='xlarge'
                            variant='primary'
                            isFullWidth={true}
                            disabled={!isGloballyResubscribed}
                            onClick={() => {
                                if (props.resubscribeUrl) {
                                    Nut.ajax.post({
                                        url: props.resubscribeUrl,
                                        data: {audienceIds: selectedAudiences},
                                        success: props.onSuccessfulResubscribe,
                                    });
                                }
                            }}
                        >
                            Save
                        </Button>
                    </StackLegacy>
                </div>
            </StackLegacy>
        </div>
    );
}
